import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Gift, Clock, ListChecks, ShoppingCart, ClipboardCheck, ArrowLeftRight, Zap, LayoutGrid, Timer, Flame, PackageCheck, CheckCircle2, Check } from 'lucide-react';
const bonuses = [{
  number: 1,
  image: 'https://cdn.magicpatterns.com/uploads/peVSuXdDcbnfaxYRVaTA8b/Bono_1.png',
  title: 'DOMINGO CERRADO',
  subtitle: 'Checklist 30 Min + Mini-Prep Sin Estrés',
  intro: 'Si tu domingo se te va "pensando" y terminás arrancando la semana igual que siempre… esto te salva.',
  label: 'Con este bono vas a poder:',
  bullets: [{
    icon: ClipboardCheck,
    text: 'Cerrar tu semana en 30 minutos con un guión paso a paso'
  }, {
    icon: ShoppingCart,
    text: 'Elegir menú + copiar lista por pasillos sin quedarte en blanco'
  }, {
    icon: Clock,
    text: 'Dejar 2 mini-preps que te compran tiempo mental'
  }, {
    icon: ListChecks,
    text: 'Escribir tu Plan B + swaps en 2 minutos para no abandonar'
  }]
}, {
  number: 2,
  image: 'https://cdn.magicpatterns.com/uploads/h5E2Nkedj9P1EqP7YQ37d7/Bono_2.png',
  title: 'SWAPS INTELIGENTES',
  subtitle: '"Si no hay X, hacé Y" (Sin Drama)',
  intro: 'Este es el bono que hace que el plan no se caiga por una pavada.',
  introExtra: 'Porque lo que te rompe la semana no es "no saber"… Es que falta un ingrediente, sube el precio, no hay stock, o cambia el día.',
  label: 'Con este bono vas a tener:',
  bullets: [{
    icon: LayoutGrid,
    text: 'Una matriz simple para reemplazar carbo/proteína/fibra sin improvisar'
  }, {
    icon: ArrowLeftRight,
    text: '"Swaps" por escenarios reales: sin súper, sin ganas, sin stock'
  }, {
    icon: Zap,
    text: 'Una tarjeta "3C en 10 segundos" para armar combos sin pensar'
  }]
}, {
  number: 3,
  image: 'https://cdn.magicpatterns.com/uploads/mHwfronhHkQVTkoJ4tGHU4/Bono_3.png',
  title: 'SALVAVIDAS 10 MIN',
  subtitle: 'Menú de Emergencia (Sin Delivery, Sin Culpa)',
  intro: 'Este es para esos días donde la cabeza no da, no cocinaste, y sentís que ya fue.',
  introExtra: 'Acá no hay motivación tóxica. Hay opciones simples para que el día no te saque del sistema.',
  label: 'Incluye:',
  bullets: [{
    icon: Timer,
    text: '10 opciones express para resolver en 10 minutos'
  }, {
    icon: ArrowLeftRight,
    text: 'Swaps por si te falta algo (sin empezar de cero)'
  }, {
    icon: PackageCheck,
    text: 'Checklist de "despensa salvavidas" para que siempre tengas plan'
  }]
}];
export function Bonuses() {
  return <Section className="py-16 md:py-20" data-id="element-1">
      {/* Section header */}
      <div className="text-center mb-6" data-id="element-2">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 text-sm font-bold tracking-wider text-amber uppercase bg-amber/10 rounded-full" data-id="element-3">
          <Gift className="w-4 h-4" data-id="element-4" />
          <span data-id="element-5">Bonos incluidos</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-6">
          Además, hoy te llevás 3 bonos (gratis)
        </h2>
      </div>

      {/* Intro text */}
      <div className="max-w-2xl mx-auto text-center mb-14 space-y-4" data-id="element-7">
        <p className="text-lg text-brown-body" data-id="element-8">
          No porque "quede lindo" decir bonos. Sino porque este sistema tiene
          que sobrevivir a la vida real.
        </p>
        <p className="text-lg text-brown-body" data-id="element-9">
          Y lo que suele romper cualquier plan no es la falta de información… Es
          la falta de cierre, los cambios de semana, y los días de cero energía.
        </p>
        <p className="text-lg font-medium text-sage-dark" data-id="element-10">
          Por eso, al descargar Semana Resuelta, te incluimos estos 3 bonos para
          que no dependas de estar "perfecta".
        </p>
      </div>

      {/* Bonus cards */}
      <div className="space-y-12" data-id="element-11">
        {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: idx * 0.1
      }} className="bg-white rounded-2xl shadow-md border border-stone-100 overflow-hidden" data-id="element-12">
            {/* Top bar */}
            <div className="bg-sage-light/40 px-6 py-3 flex items-center justify-between border-b border-sage/10" data-id="element-13">
              <div className="flex items-center gap-2" data-id="element-14">
                <div className="w-7 h-7 rounded-full bg-sage text-white flex items-center justify-center text-sm font-bold" data-id="element-15">
                  {bonus.number}
                </div>
                <span className="text-sm font-bold text-sage-dark uppercase tracking-wide" data-id="element-16">
                  Bono #{bonus.number}
                </span>
              </div>
              <div className="flex items-center gap-1.5 text-xs font-bold text-amber bg-amber/10 px-3 py-1 rounded-full" data-id="element-17">
                <Flame className="w-3.5 h-3.5" data-id="element-18" />
                <span data-id="element-19">Valor: ARS 47.000 — GRATIS</span>
              </div>
            </div>

            <div className="p-6 md:p-8" data-id="element-20">
              <div className="flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-21">
                {/* Image */}
                <div className="flex-shrink-0 mx-auto md:mx-0" data-id="element-22">
                  <img src={bonus.image} alt={`Mockup del bono ${bonus.number}: ${bonus.title}`} className="w-48 md:w-44 rounded-lg shadow-lg" data-id="element-23" />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-24">
                  <h3 className="text-2xl font-bold text-brown-heading mb-1" data-id="element-25">
                    {bonus.title}
                  </h3>
                  <p className="text-lg font-medium text-amber mb-4" data-id="element-26">
                    {bonus.subtitle}
                  </p>

                  <p className="text-brown-body mb-2" data-id="element-27">{bonus.intro}</p>
                  {bonus.introExtra && <p className="text-brown-body mb-4" data-id="element-28">{bonus.introExtra}</p>}

                  <p className="text-sm font-bold text-brown-heading mb-3 uppercase tracking-wide" data-id="element-29">
                    {bonus.label}
                  </p>

                  <ul className="space-y-3" data-id="element-30">
                    {bonus.bullets.map((bullet, bIdx) => <motion.li key={bIdx} initial={{
                  opacity: 0,
                  x: -10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.2 + bIdx * 0.1
                }} className="flex items-start gap-3" data-id="element-31">
                        <div className="mt-0.5 p-1 bg-sage-light rounded-md flex-shrink-0" data-id="element-32">
                          <bullet.icon className="w-4 h-4 text-sage-dark" data-id="element-33" />
                        </div>
                        <span className="text-brown-body" data-id="element-34">{bullet.text}</span>
                      </motion.li>)}
                  </ul>

                  <p className="mt-5 text-sm font-bold text-sage-dark" data-id="element-35">
                    Te lo llevás GRATIS hoy. (Valor: ARS 47.000)
                  </p>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>

      {/* Summary */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="mt-14 bg-sage-light/30 rounded-2xl p-6 md:p-8" data-id="element-36">
        <h3 className="text-xl font-bold text-center mb-6 text-brown-heading" data-id="element-37">
          Resumen: lo que recibís
        </h3>
        <div className="space-y-3 max-w-md mx-auto" data-id="element-38">
          {['Semana Resuelta (PDF principal)', 'Bono 1: Domingo Cerrado (ARS 47.000 — gratis)', 'Bono 2: Swaps Inteligentes (ARS 47.000 — gratis)', 'Bono 3: Salvavidas 10 Min (ARS 47.000 — gratis)'].map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-39">
              <div className="w-5 h-5 rounded-full bg-sage text-white flex items-center justify-center flex-shrink-0" data-id="element-40">
                <Check className="w-3 h-3" strokeWidth={3} data-id="element-41" />
              </div>
              <span className={`${idx === 0 ? 'font-bold text-brown-heading' : 'text-brown-body'}`} data-id="element-42">
                {item}
              </span>
            </div>)}
        </div>
      </motion.div>
    </Section>;
}